
import { computed } from 'vue'
import { useStore } from '@/store/index.ts'
import BreadcrumbIndex from '@/layout/navBars/breadcrumb/index.vue'
import TagsView from '@/layout/navBars/tagsView/tagsView.vue'
export default {
  name: 'layoutNavBars',
  components: { BreadcrumbIndex, TagsView },
  setup () {
    const store = useStore()
    // 是否显示 tagsView
    const setShowTagsView = computed(() => {
      const { layout, isTagsview } = store.state.themeConfig.themeConfig
      return layout !== 'classic' && isTagsview
    })
    return {
      setShowTagsView
    }
  }
}
